import { useEffect } from 'react';
import i18n from '@app/app/i18n/config';

/**
 * Хук для автоматической установки dir="rtl" для арабского языка
 * Устанавливает dir="rtl" на <html> элементе при смене языка на арабский
 * и dir="ltr" для остальных языков
 */
export const useRtlDirection = () => {
  useEffect(() => {
    const htmlElement = document.documentElement;
    const currentLanguage = i18n.language;

    if (currentLanguage === 'ar') {
      htmlElement.setAttribute('dir', 'rtl');
    } else {
      htmlElement.setAttribute('dir', 'ltr');
    }

    // Слушаем изменения языка
    const handleLanguageChange = (lng: string) => {
      if (lng === 'ar') {
        htmlElement.setAttribute('dir', 'rtl');
      } else {
        htmlElement.setAttribute('dir', 'ltr');
      }
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);
};
